/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { List as AntdList } from 'antd';
import clsx from 'clsx';

import s from './styles.module.less';

const List = ({ className, ...props }) => <AntdList className={clsx(s.custom, className)} {...props} />;

List.Item = AntdList.Item;

export default List;
